<div class="report-img-container">
    <img class="report-image" src='{{stepinfo.fileName}}' (click)="openImage(stepinfo.fileName)" />
</div>

<div class="prediction-info" *ngIf="getValidPredictions().length">
    <p>{{'report_supervisor_value' | translate}}</p>
    <p *ngFor="let prediction of getValidPredictions()">{{prediction.Label}} {{'prediction_probability' | translate}}{{prediction.ProbabilityString}}</p>
</div>

<div class="text-info" *ngIf="!getValidPredictions().length">
    <p>{{'too_low_probability' | translate}}</p>
</div>
